/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Constants used in this component library
 *
 * @file constants.js
 * @since 1.0.0
 */
export const AUDIO_FILE_TYPE = 'audio';
export const BULK_DOWNLOAD_STATUS_COMPLETED = 'Completed';
export const BULK_DOWNLOAD_STATUS_ERROR = 'error';
export const BULK_DOWNLOAD_STATUS_INPROGRESS = 'Inprogress';
export const BULK_DOWNLOAD_STATUS_NOT_STARTED = 'NotStarted';
export const BULK_DOWNLOAD_STATUS_REMOVING = 'Removing';
export const CONTENT_TITLE_AUDIO = 'Audio';
export const CONTENT_TITLE_DOCUMENT = 'Documents';
export const CONTENT_TITLE_INTERACTIVE = 'Activities';
export const CONTENT_TITLE_INTERNAL_LINK = 'Internal Links';
export const CONTENT_TITLE_OTHER = 'Misc';
export const CONTENT_TITLE_OTHER_ICON = 'Misc';
export const CONTENT_TITLE_PICTURE = 'Images';
export const CONTENT_TITLE_FIGURE = 'Figures';
export const CONTENT_TITLE_QUIZ = 'Quizzes';
export const CONTENT_TITLE_VIDEO = 'Videos';
export const CONTENT_TITLE_WEB_LINK = 'Web Links';
export const CONTENT_TITLE_ZIP = 'Zipped Files';
export const CONTENT_TITLE_SPARK_LAB = 'SPARKLab';

export const CONTENT_TYPE_AUDIO = 'audio';
export const CONTENT_TYPE_DOCUMENT = 'document';
export const CONTENT_TYPE_INTERACTIVE = 'interactive';
export const CONTENT_TYPE_INTERNAL_LINK = 'internal-link';
export const CONTENT_TYPE_PICTURE = 'picture';
export const CONTENT_TYPE_FIGURE = 'image';
export const CONTENT_TYPE_QUIZ = 'quiz';
export const CONTENT_TYPE_VIDEO = 'video';
export const CONTENT_TYPE_WEB_LINK = 'weblink';
export const CONTENT_TYPE_ZIP = 'zip';
export const CONTENT_TYPE_SPARK_LAB = 'sparklab';

export const DEFAULT_LOCALE = 'en';
export const DRAWER_STATE_CLOSED = 'closed';
export const DRAWER_STATE_EXPANDED = 'expanded';
export const DRAWER_STATE_OPEN = 'open';
export const DOWNLOAD_STATE_WAIT_TIME = 5000;
export const DOWNLOAD_STATUS_COMPLETED = 'COMPLETED';
export const DOWNLOAD_STATUS_DELETING = 'DELETING';
export const DOWNLOAD_STATUS_ERROR = 'FAILED';
export const DOWNLOAD_STATUS_INPROGRESS = 'DOWNLOADING';
export const DOWNLOAD_STATUS_START_DOWNLOAD = 'NOT_DOWNLOADED';
export const LEFT_PANEL_WIDTH = '495';
export const RESOURCE_REQUESTED = 'RESOURCE_REQUESTED';
export const RESOURCES_TITLE = 'Resources';
export const SELECT_ALL = 'SELECTALL';
export const THEME_DARK = 'dark';
export const THEME_SEPIA = 'sepia';
// ====
export const USER_ROLE_INSTRUCTOR = 'Teacher';
export const USER_ROLE_STUDENT = 'Student';
export const BOOK_LEVEL_RESOURCE = 'Book';
export const PAGE_LEVEL_RESOURCE = 'Page';
export const CONTENT_TYPE_KEYS = {
  TYPE: 'type',
  LABEL: 'label',
  ICON: 'icon'
};
export const CONTENT_TYPE_DATA_CONNECTION = [
  {
    type: CONTENT_TYPE_AUDIO,
    label: CONTENT_TITLE_AUDIO,
    icon: 'Audio'
  },
  {
    type: CONTENT_TYPE_DOCUMENT,
    label: CONTENT_TITLE_DOCUMENT,
    icon: 'Document'
  },
  {
    type: CONTENT_TYPE_INTERACTIVE,
    label: CONTENT_TITLE_INTERACTIVE,
    icon: 'Activities'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    label: CONTENT_TITLE_INTERNAL_LINK,
    icon: 'Links'
  },
  {
    type: CONTENT_TYPE_PICTURE,
    label: CONTENT_TITLE_PICTURE,
    icon: 'Image'
  },
  {
    type: CONTENT_TYPE_FIGURE,
    label: CONTENT_TITLE_FIGURE,
    icon: 'Figure'
  },
  {
    type: CONTENT_TYPE_QUIZ,
    label: CONTENT_TITLE_QUIZ,
    icon: 'Quizzes'
  },
  {
    type: CONTENT_TYPE_VIDEO,
    label: CONTENT_TITLE_VIDEO,
    icon: 'Video'
  },
  {
    type: CONTENT_TYPE_WEB_LINK,
    label: CONTENT_TITLE_WEB_LINK,
    icon: 'WebLinks'
  },
  {
    type: CONTENT_TYPE_ZIP,
    label: CONTENT_TITLE_ZIP,
    icon: 'ZippedFiles'
  },
  {
    type: CONTENT_TYPE_SPARK_LAB,
    label: CONTENT_TITLE_SPARK_LAB,
    icon: 'SparkLab'
  }
];
export const EMPTY_RESOURCE = 'EMPTY';
